import React from 'react';
import { createPortal } from 'react-dom';
import { DocumentRefused } from 'assets/svg/sendDocuments';

export default function ModalDocument({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
  if (!isOpen) return null;

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleModalClose = () => {
    console.log('Modal: Fechando modal - documentos reprovados serão limpos automaticamente')
    onClose();
  };

  return createPortal(
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center" 
      style={{ 
        margin: 0, 
        padding: 0, 
        top: 0, 
        left: 0, 
        right: 0, 
        bottom: 0,
        width: '100vw',
        height: '100vh'
      }}
    >
      <div 
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={handleModalClose}
      />
      
      <div className="relative bg-white rounded-lg p-8 max-w-sm w-full mx-4">
        <div className="flex flex-col items-center text-center space-y-4">
          <DocumentRefused />
          
          <h2 className="text-lg font-medium text-gray-900">
            Documento divergente
          </h2>
          
          <p className="text-gray-600 text-sm">
            O documento enviado não atende aos requisitos. Verifique e tente novamente.
          </p>
          
          <button
            onClick={handleModalClose}
            className="w-full mt-6 px-4 py-2 border-none bg-primary hover:bg-primary-dark text-white rounded-md transition-colors"
          >
            Revisar documento
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}